/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/km-product-translate.js
 * Injecte les traductions dans le DOM de la page produit
 * Doit être chargé APRÈS km-product-i18n.js
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  var T = window.KM_T;
  if (!T) return;

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return document.querySelectorAll(sel); }
  function setText(el, txt) { if (el) el.textContent = txt; }
  function setHTML(el, txt) { if (el) el.innerHTML = txt; }

  /* ══════════ SECTION 3 : Formulaire produit ══════════ */

  // Trust row
  var trustRow = q('.km-posters-grid');
  if (trustRow) {
    var mainWrap = trustRow.closest('.product__info-container') || trustRow.closest('[id^="ProductInfo"]') || document.body;

    // Trust badges
    var trustSpans = mainWrap.querySelectorAll('[style*="text-decoration:underline"]');
    if (trustSpans.length) setText(trustSpans[0], T.trust_reviews);
    var eventBadge = mainWrap.querySelector('[style*="background:#F7F0E4"]');
    if (eventBadge) setText(eventBadge, T.trust_events);

   // Title h1 — géré côté serveur par Liquid {{ product.title }}, ne pas écraser
    // (supprimé volontairement pour éviter "undefined" quand T.product_title n'existe plus)
    var h1 = mainWrap.querySelector('h1');

    // Short description (first p after h1)
    if (h1 && h1.nextElementSibling && h1.nextElementSibling.tagName === 'P') {
      setText(h1.nextElementSibling, T.product_desc);
    }

    // Price label
    var priceLabels = mainWrap.querySelectorAll('[style*="text-transform:uppercase"][style*="letter-spacing:1.5px"]');
    priceLabels.forEach(function (el) {
      if (el.textContent.trim() === 'Prix' || el.textContent.trim() === 'Price') {
        setText(el, T.price_label);
      }
    });

    // Price badges
    var badges = mainWrap.querySelectorAll('[style*="border-radius:100px"]');
    badges.forEach(function (b) {
      var t = b.textContent.trim();
      if (t === 'Paiement unique' || t === 'One-time payment') setText(b, T.price_badge_1);
      if (t.indexOf('Accès 6 mois') !== -1 || t.indexOf('6-month access') !== -1) setText(b, T.price_badge_2);
    });

    // Info 6 months box
    var infoBox = mainWrap.querySelector('[style*="background:rgba(201,169,110,0.08)"] div');
    if (infoBox) {
      var strong = infoBox.querySelector('strong');
      if (strong) setText(strong, T.info_6m_strong);
      // Replace text after strong
      if (strong && strong.nextSibling) {
        strong.nextSibling.textContent = T.info_6m_text;
      }
    }
  }

  // Poster selector
  var selLabel = q('#km-selected-name');
  if (selLabel && (selLabel.textContent.indexOf('Aucun') !== -1 || selLabel.textContent.indexOf('No design') !== -1)) {
    setText(selLabel, T.poster_none);
  }
  var posterTitle = q('[style*="font-weight:500"][style*="color:#1A1714"]');

  // Poster zoom hint
  qa('.km-poster-zoom-overlay span').forEach(function (s) {
    setText(s, T.poster_zoom_overlay);
  });

  // Error messages
  var errPoster = q('#km-error-poster');
  if (errPoster) setHTML(errPoster, T.error_poster);
  var errName = q('#km-error-name');
  if (errName) setHTML(errName, T.error_name);

  // Form labels
  var nameLabel = q('label[for="km-customer-name"]');
  if (nameLabel) setHTML(nameLabel, T.form_name_label + ' <span class="req">*</span>');
  var nameInput = q('#km-customer-name');
  if (nameInput) nameInput.placeholder = T.form_name_placeholder;
  var nameCounter = q('#km-name-counter');
  if (nameCounter) setText(nameCounter, '0' + T.form_name_counter_suffix);

  var previewLabel = q('#km-name-preview .label');
  if (previewLabel) setText(previewLabel, T.form_preview);

  var eventLabel = q('label[for="km-event-type"]');
  if (eventLabel) setHTML(eventLabel, T.form_event_label + ' <span class="opt">' + T.form_event_opt + '</span>');
  var eventInput = q('#km-event-type');
  if (eventInput) eventInput.placeholder = T.form_event_placeholder;
  var eventCounter = q('#km-event-counter');
  if (eventCounter) setText(eventCounter, '0' + T.form_event_counter_suffix);
  var eventHelper = q('.km-form-helper');
  if (eventHelper) setText(eventHelper, T.form_event_helper);

  // Form section title (Personnalisez votre carte de table)
  var formSectionTitles = qa('[style*="font-weight:500"][style*="color:#1A1714"][style*="gap:8px"]');
  formSectionTitles.forEach(function (el) {
    var svg = el.querySelector('svg');
    if (svg) {
      el.innerHTML = '';
      el.appendChild(svg);
      el.appendChild(document.createTextNode(' ' + T.form_title));
    }
  });

  // ATC button
  var atcBtn = q('#km-atc-btn');
  if (atcBtn) setText(atcBtn, T.atc_btn);

  // Quick features
  var feats = qa('.km-feature-item');
  var featTexts = [T.feat_1, T.feat_2, T.feat_3, T.feat_4, T.feat_5, T.feat_6];
  feats.forEach(function (f, i) {
    if (featTexts[i]) {
      var icon = f.querySelector('.km-feature-icon');
      if (icon) {
        f.innerHTML = '';
        f.appendChild(icon);
        f.appendChild(document.createTextNode(' ' + featTexts[i]));
      }
    }
  });

  // Payment label
  var payLabel = q('.km-pay-label');
  if (payLabel) setText(payLabel, T.pay_label);

  // Micro reassurance
  var reassItems = qa('.km-reassurance-item');
  var reassTexts = [T.reassurance_1, T.reassurance_2, T.reassurance_3];
  reassItems.forEach(function (r, i) {
    if (reassTexts[i]) {
      var svg = r.querySelector('svg');
      if (svg) {
        r.innerHTML = '';
        r.appendChild(svg);
        r.appendChild(document.createTextNode('\n    ' + reassTexts[i]));
      }
    }
  });

  // Garantie
  var garantieTitle = q('.km-garantie h4');
  if (garantieTitle) setText(garantieTitle, T.garantie_title);
  var garantieText = q('.km-garantie p');
  if (garantieText) setText(garantieText, T.garantie_text);

  // FAQ accordion
  var faqLabel = q('.km-faq-item');
  if (faqLabel && faqLabel.previousElementSibling) {
    var faqHeader = faqLabel.parentElement.querySelector('[style*="text-transform:uppercase"]');
    if (faqHeader) setText(faqHeader, T.faq_label);
  }
  var faqBtns = qa('.km-faq-btn');
  var faqQs = [T.faq_q1, T.faq_q2, T.faq_q3, T.faq_q4, T.faq_q5];
  var faqAs = [T.faq_a1, T.faq_a2, T.faq_a3, T.faq_a4, T.faq_a5];
  faqBtns.forEach(function (btn, i) {
    if (faqQs[i]) {
      // Update text without destroying the element — preserve event listeners
      var textNode = null;
      for (var c = 0; c < btn.childNodes.length; c++) {
        if (btn.childNodes[c].nodeType === 3 && btn.childNodes[c].textContent.trim()) {
          textNode = btn.childNodes[c];
          break;
        }
      }
      if (textNode) {
        textNode.textContent = faqQs[i] + ' ';
      } else {
        // Fallback: rebuild but re-attach handler
        var arrow = btn.querySelector('.km-faq-arrow');
        btn.innerHTML = '';
        btn.appendChild(document.createTextNode(faqQs[i] + ' '));
        if (arrow) btn.appendChild(arrow);
      }
    }
    var answer = btn.nextElementSibling;
    if (answer && faqAs[i]) setText(answer, faqAs[i]);
  });

  // Re-bind FAQ accordion click handlers (in case innerHTML destroyed them)
  qa('.km-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var answer = item.querySelector('.km-faq-answer');
      var arrow = btn.querySelector('.km-faq-arrow');
      var isOpen = answer && answer.style.display === 'block';
      qa('.km-faq-answer').forEach(function (a) { a.style.display = 'none'; });
      qa('.km-faq-arrow').forEach(function (a) { a.textContent = '▼'; });
      if (!isOpen && answer) {
        answer.style.display = 'block';
        if (arrow) arrow.textContent = '▲';
      }
    });
  });

  // Override JS counter text
  if (nameInput) {
    nameInput.addEventListener('input', function () {
      var len = nameInput.value.length;
      if (nameCounter) nameCounter.textContent = len + T.form_name_counter_suffix;
    });
  }
  if (eventInput) {
    eventInput.addEventListener('input', function () {
      if (eventCounter) eventCounter.textContent = eventInput.value.length + T.form_event_counter_suffix;
    });
  }

  /* ══════════ SECTION 5 : Pourquoi KeepMemoriz ══════════ */
  var whyTag = q('.km-why-tag');
  if (whyTag) setText(whyTag, T.why_tag);

  var whyH2 = q('.km-why-h2');
  if (whyH2) setHTML(whyH2, T.why_title);

  var whySub = q('.km-why-sub');
  if (whySub) setText(whySub, T.why_sub);

  // Column titles
  var colTitles = qa('.km-why-col-title');
  if (colTitles.length >= 2) {
    setText(colTitles[0], T.why_bad_title);
    setText(colTitles[1], T.why_good_title);
  }

  // Bad list
  var badItems = qa('.km-why-list.bad li');
  badItems.forEach(function (li, i) {
    if (T.why_bad[i]) {
      var icon = li.querySelector('.km-wl-icon');
      li.innerHTML = '';
      if (icon) li.appendChild(icon);
      li.appendChild(document.createTextNode(' ' + T.why_bad[i]));
    }
  });

  // Good list
  var goodItems = qa('.km-why-list.good li');
  goodItems.forEach(function (li, i) {
    if (T.why_good[i]) {
      var icon = li.querySelector('.km-wl-icon');
      li.innerHTML = '';
      if (icon) li.appendChild(icon);
      li.appendChild(document.createTextNode(' ' + T.why_good[i]));
    }
  });

  // Stats labels
  var statLabels = qa('.km-why-stat-label');
  var statTexts = [T.why_stat1_label, T.why_stat2_label, T.why_stat3_label, T.why_stat4_label];
  statLabels.forEach(function (el, i) {
    if (statTexts[i]) setText(el, statTexts[i]);
  });

  // CTA
  var ctaBtn = q('.km-why-cta-btn');
  if (ctaBtn) setText(ctaBtn, T.why_cta);

  var ctaSubs = qa('.km-why-cta-sub span');
  if (ctaSubs.length >= 5) {
    ctaSubs[0].innerHTML = T.why_cta_sub1;
    ctaSubs[2].innerHTML = T.why_cta_sub2;
    ctaSubs[4].innerHTML = T.why_cta_sub3;
  }

  // Demo after compare
  var demoQ = q('.km-demo-after-compare p');
  if (demoQ) setText(demoQ, T.why_demo_q);
  var demoBtn = q('.km-demo-after-compare a');
  if (demoBtn) {
    var svg = demoBtn.querySelector('svg');
    demoBtn.innerHTML = '';
    if (svg) demoBtn.appendChild(svg);
    demoBtn.appendChild(document.createTextNode('\n      ' + T.why_demo_btn));
  }

  // Sticky bar
  var stickyName = q('.km-sticky-name');
  if (stickyName) setText(stickyName, T.sticky_name);
  var stickyBtn = q('.km-sticky-btn');
  if (stickyBtn) setText(stickyBtn, T.sticky_btn);

  /* ══════════ SECTION 6 : Vidéos étapes ══════════ */
  var gifsTag = q('.km-gifs-tag');
  if (gifsTag) setText(gifsTag, T.vid_tag);

  var gifsH2 = q('.km-gifs-h2');
  if (gifsH2) setHTML(gifsH2, T.vid_title);

  var gifsSub = q('.km-gifs-sub');
  if (gifsSub) setText(gifsSub, T.vid_sub);

  // Video badges
  var vidBadges = qa('.km-video-badge');
  vidBadges.forEach(function (b, i) {
    setText(b, T.vid_step + ' 0' + (i + 1));
  });

  // Video placeholders
  var vidPlaceholders = qa('.km-vp-num');
  vidPlaceholders.forEach(function (p, i) {
    setText(p, T.vid_placeholder + ' ' + (i + 1));
  });

  // Step nums
  var gifNums = qa('.km-gif-num');
  gifNums.forEach(function (n, i) {
    setText(n, T.vid_step + ' 0' + (i + 1));
  });

  // Step titles & descs
  var gifTitles = qa('.km-gif-title');
  var gifDescs = qa('.km-gif-desc');
  var sTitles = [T.vid_s1_title, T.vid_s2_title, T.vid_s3_title, T.vid_s4_title];
  var sDescs = [T.vid_s1_desc, T.vid_s2_desc, T.vid_s3_desc, T.vid_s4_desc];
  gifTitles.forEach(function (t, i) { if (sTitles[i]) setText(t, sTitles[i]); });
  gifDescs.forEach(function (d, i) { if (sDescs[i]) setText(d, sDescs[i]); });

  // Demo after steps
  var demoStepsP = q('.km-demo-after-steps p');
  if (demoStepsP) setText(demoStepsP, T.vid_demo_text);
  var demoStepsBtn = q('.km-demo-after-steps a');
  if (demoStepsBtn) {
    var svg2 = demoStepsBtn.querySelector('svg');
    demoStepsBtn.innerHTML = '';
    if (svg2) demoStepsBtn.appendChild(svg2);
    demoStepsBtn.appendChild(document.createTextNode('\n    ' + T.vid_demo_btn));
  }
  var demoNote = q('.km-demo-note');
  if (demoNote) setText(demoNote, T.vid_demo_note);

  /* ══════════ SECTION 7 : Carrousel avis ══════════ */
  var revCount = q('.km-reviews-count');
  if (revCount) setText(revCount, T.reviews_count);

  var revTitle = q('.km-reviews-right h2');
  if (revTitle) setHTML(revTitle, T.reviews_title);

  var revSub = q('.km-reviews-right p');
  if (revSub) setText(revSub, T.reviews_sub);

  // Translate review cards (only if translations exist)
  if (T.reviews_track1) {
    var track1 = q('#km-track1');
    if (track1) {
      var origCards1 = track1.querySelectorAll('.km-review-card');
      var uniqueCount1 = T.reviews_track1.length;
      origCards1.forEach(function (card, i) {
        var idx = i % uniqueCount1;
        var textEl = card.querySelector('.km-rv-text');
        if (textEl && T.reviews_track1[idx]) setText(textEl, T.reviews_track1[idx]);
      });
    }
  }
  if (T.reviews_track2) {
    var track2 = q('#km-track2');
    if (track2) {
      var origCards2 = track2.querySelectorAll('.km-review-card');
      var uniqueCount2 = T.reviews_track2.length;
      origCards2.forEach(function (card, i) {
        var idx = i % uniqueCount2;
        var textEl = card.querySelector('.km-rv-text');
        if (textEl && T.reviews_track2[idx]) setText(textEl, T.reviews_track2[idx]);
      });
    }
  }

  /* ══════════ POSTER SELECTOR FIXES ══════════ */
  // Poster section title "Choisissez votre carte de table QR code"
  var posterTitleEls = qa('[style*="font-size:14px"][style*="font-weight:500"][style*="color:#1A1714"]');
  posterTitleEls.forEach(function (el) {
    if (el.textContent.indexOf('Choisissez') !== -1 || el.textContent.indexOf('Choose') !== -1) {
      setHTML(el, T.poster_title + ' <span style="color:#dc2626;">*</span>');
    }
  });

  // Poster zoom hint
  var zoomHints = qa('[style*="color:#8C7B6E"][style*="margin-bottom:12px"]');
  zoomHints.forEach(function (el) {
    if (el.textContent.indexOf('Cliquez') !== -1 || el.textContent.indexOf('Click') !== -1) {
      setText(el, T.poster_zoom);
    }
  });

  // Translate the global kmPosters array names + descriptions (used by modal)
  if (window.kmPosters && T.poster_descs) {
    window.kmPosters.forEach(function (p, i) {
      if (T.poster_descs[i]) p.desc = T.poster_descs[i];
      if (T.poster_names && T.poster_names[i]) p.name = T.poster_names[i];
      if (T.poster_imgs && T.poster_imgs[i]) p.img = T.poster_imgs[i];
    });
  }

  // Translate poster name overlays in the grid
  if (T.poster_names) {
    var nameOverlays = qa('.km-poster-name-overlay');
    nameOverlays.forEach(function (el, i) {
      if (T.poster_names[i]) setText(el, T.poster_names[i]);
    });
    // Also update data-name attributes on poster items (used by select logic)
    var posterItems = qa('.km-poster-item');
    posterItems.forEach(function (item, i) {
      if (T.poster_names[i]) item.setAttribute('data-name', T.poster_names[i]);
      if (T.poster_imgs && T.poster_imgs[i]) { var img = item.querySelector('img'); if (img) img.src = T.poster_imgs[i]; }
    });
  }

  // Modal select buttons — translate BOTH (Custom Liquid + theme.liquid modals)
  var allModalBtns = qa('#km-modal-select, #km-modal-select-btn');
  allModalBtns.forEach(function (btn) {
    setText(btn, T.modal_select);
    btn.style.background = '#C9A96E';
  });

  // Helper to fix ALL modal select buttons
  function fixAllModalBtns(isSelected) {
    qa('#km-modal-select, #km-modal-select-btn').forEach(function (btn) {
      btn.textContent = isSelected ? T.modal_selected : T.modal_select;
      btn.style.background = isSelected ? '#22c55e' : '#C9A96E';
    });
  }

  // Override kmOpenModal to use translated button text
  if (typeof window.kmOpenModal === 'function') {
    var _origOpen = window.kmOpenModal;
    window.kmOpenModal = function (idx) {
      _origOpen(idx);
      // Fix button text after original function sets it in FR
      var isSelected = window.kmSelectedId === window.kmPosters[idx].id;
      fixAllModalBtns(isSelected);
      // Also fix modal name/desc in case the original used old data
      var nameEl = document.getElementById('km-modal-name');
      var descEl = document.getElementById('km-modal-desc');
      if (nameEl) nameEl.textContent = window.kmPosters[idx].name;
      if (descEl) descEl.textContent = window.kmPosters[idx].desc;
    };
  }

  // Override kmSelectFromModal to use translated text
  if (typeof window.kmSelectFromModal === 'function') {
    var _origSelect = window.kmSelectFromModal;
    window.kmSelectFromModal = function () {
      _origSelect();
      fixAllModalBtns(true);
    };
  }

  // Also intercept the Custom Liquid modal's inline select handler
  var csModalSelect = q('#km-modal-select');
  if (csModalSelect) {
    csModalSelect.addEventListener('click', function () {
      setTimeout(function () { fixAllModalBtns(true); }, 50);
    });
  }

  // Also translate the counter text format in the name input handler
  if (window.kmNameInput || q('#km-customer-name')) {
    var ni = q('#km-customer-name');
    var nc = q('#km-name-counter');
    if (ni && nc) {
      ni.addEventListener('input', function () {
        nc.textContent = ni.value.length + T.form_name_counter_suffix;
      });
    }
  }
  if (q('#km-event-type') && q('#km-event-counter')) {
    var ei = q('#km-event-type');
    var ec = q('#km-event-counter');
    ei.addEventListener('input', function () {
      ec.textContent = ei.value.length + T.form_event_counter_suffix;
    });
  }

})();
